import { create } from "zustand";
import { closeOtherModals, registerModalStore } from "./modal-registry";

/** Key this store is known by in the modal registry. */
const MODAL_NAME = "save-as-new-collection";

/**
 * The "Save as new collection" modal: name and room-type a copy of somebody else's collection.
 */
export const useSaveAsNewCollectionModalStore = create((set) => ({
  isModalOpen: false,
  formUrl: null,
  collectionId: null,

  openModal: ({ formUrl, collectionId }) => {
    closeOtherModals(MODAL_NAME);

    set({ isModalOpen: true, formUrl, collectionId });
  },
  closeModal: () => set({ isModalOpen: false, formUrl: null, collectionId: null }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));

registerModalStore(MODAL_NAME, useSaveAsNewCollectionModalStore);
